<template>
  <div class="filter-item">
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-field v-if="!loadStatus">
          <label for="citie">{{ t('shop.title.cities') }}</label>
          <md-select v-model="value" name="citie" id="citie" @md-selected="changeFilter" md-dense>
            <md-option  value="deleteFilter"  :key="'deleteFilter'">{{ t('shop.select.option.all') }}</md-option>
            <md-option v-for="v in items"
                       :value="v.id"
                      :key="v.id">{{ v.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="loading-overlay" v-if="loadStatus">
      <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
    </div>
  </div>
</template>

<script>
import cacheCt from '@/cahces/cities'
export default {
  name: 'shopFilterCities',
  data () {
    return {
      items: [],
      value: null,
      loadStatus: true
    }
  },

  methods: {
    getListCities () {
      this.startLoading()
      return cacheCt.get()
    },
    changeFilter () {
      this.$store.commit('setFilter', {name: 'city_id', value: this.value})
      this.$emit('changeFilter')
    },
    startLoading () {
      this.loadStatus = true
    },
    stopLoading () {
      this.loadStatus = false
    }
  },
  async created () {
    const $this = this
    let data = await Promise.resolve($this.getListCities())
    if (data) {
      this.items = data
      if (this.$store.state.filtersShop['city_id'] !== null) {
        this.value = this.$store.state.filtersShop.city_id
      }
      this.stopLoading()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/filters/shop/cities.vue